import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
    sticky: false,
    contentShow: false,
    companyContent: {
        title: '',
        body: ''
    }
}

const getters = {
    sticky: state => {
        return state.sticky;
    },
    contentShow: state => {
        return state.contentShow;
    },
    companyContent: state => {
        return state.companyContent
    }
}

const mutations = {
    mutateSticky: state => {
        state.sticky = !state.sticky;
    },
    mutateContentShow: (state, payload) => {
        state.contentShow = payload;
    },
    mutateCompanyContent: (state, payload) => {
        state.companyContent = payload
    }
}

const actions = {
    updateSticky: ({ commit }) => {
        commit('mutateSticky');
    },
    updateContentShow: ({ commit }, payload) => {
        commit('mutateContentShow', payload);
    },
    updateCompanyContent: ({ commit }, {title, body}) => {
        commit('mutateCompanyContent', {title, body});
    }
}

export const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});



// WEBPACK FOOTER //
// ./src/store/store.js